// src/components/page-renderer/ComponentRenderer.jsx
export default function ComponentRenderer({ component }) {
  const { type, data } = component;

  if (type === "text") {
    return (
      <div className="text-gray-700 text-lg leading-relaxed">
        {data.text}
      </div>
    );
  }

  if (type === "image") {
    return (
      <img
        src={data.src}
        alt={data.alt || ""}
        className="w-full rounded-xl object-cover"
      />
    );
  }

  if (type === "button") {
    return (
      <a
        href={data.url || "#"}
        className="inline-block px-6 py-3 bg-indigo-600 text-white rounded-lg"
      >
        {data.label || "Saiba mais"}
      </a>
    );
  }

  if (type === "html") {
    return (
      <div
        dangerouslySetInnerHTML={{ __html: data.html }}
      />
    );
  }

  if (type === "forum") {
    return (
      <div className="border rounded-xl p-6 bg-gray-50">
        <h3 className="font-bold text-xl mb-2">Fórum</h3>
        <p>Área de fórum integrada</p>
      </div>
    );
  }

  return null;
}
